module.exports = __webpack_public_path__ + "img/Huerenaff.c464af8f.svg";